import React, {
  InputHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';

import { useField, FormHandles } from '@unform/core';
import { IconBaseProps } from 'react-icons';
import { FiAlertCircle } from 'react-icons/fi';

import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Container } from './styles';
import { Error } from '../styles';
import { uuid } from 'uuidv4';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
  setCallback?: Function;
  formRef?: React.RefObject<FormHandles>;
  defaultV ?: string;
} 

const Input: React.FC<InputProps> = ({
  name,
  icon: Icon,
  formRef,
  setCallback = () => {},
  defaultV,
  ...rest
}) => {
  const { fieldName, defaultValue, error, registerField } = useField(name);
  const inputRef = useRef<HTMLInputElement>(null);
   
  const selectRef : any = useRef(null);

  const [ready, setReady] = useState(false);
 
  const [currentValue, setCurrentValue] = useState(defaultV || '');

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      path: undefined,

      getValue: (ref: any) => {
        return currentValue;
      },
      setValue: (ref: any, value) => {
     
        setCurrentValue(value);
         setReady(true)
  
       
      },
    });
  }, [fieldName, registerField, currentValue]);

 

  useEffect(() => {
    registerField({ name: fieldName, ref: selectRef.current, path: 'value' });
  }, [fieldName, registerField]);

  return (
    <Container
      {...rest}
      isErrored={!!error}
   
    >
      <span>{rest.placeholder}</span>
      {Icon && <Icon />}
  <CKEditor  
        ref={selectRef}
        editor={ClassicEditor}
        data={currentValue}
            onInit={editor => {
console.log('iniciou', currentValue)
          editor.data.set(currentValue)


        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          setCurrentValue(data);
        }}
       
      /> 

      {error && (
        <Error title={error}>
          <FiAlertCircle />
        </Error>
      )}
    </Container>
  );
};

export default Input;
